import { Colors } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import { Link } from "react-router-dom";

const styles = {
	footer: css({
		backgroundColor: Colors.DARK_GRAY5,
		color: Colors.LIGHT_GRAY5 + " !important",
		padding: "20px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		position: "absolute",
		bottom: "0",
		width: "100%",
		maxWidth: "1100px",
		height: "60px",
	}),
	left: css({ fontSize: "20px" }),
	right: css({ fontSize: "15px" }),
	center: css({ fontSize: "10px" }),
	link: css({
		color: Colors.LIGHT_GRAY5,
		textDecoration: "underline",
		":hover": { color: Colors.LIGHT_GRAY4 },
	}),
};

interface Props {
	dark: boolean;
}

const Footer: React.FC<Props> = ({ dark }) => {
	return (
		<div {...styles.footer}>
			<div {...styles.left}>SYPT Fight-Manager</div>
			<div {...styles.center}>
				<Link to="/privacy/" {...styles.link}>
					Privacy Policy
				</Link>
			</div>
			<div {...styles.right}>© by Marc Bitterli</div>
		</div>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Public/Footer.tsx